<template>
<ul class="uix-list">
  <slot></slot>
</ul>
</template>
<script>
export default {
}
</script>


// WEBPACK FOOTER //
// List.vue?3ed23462